<template>
  <div class="w80-login my-20">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="px-5 mx-10">
          <h1 class="font-white font-regular text-left ms-10 mb-2 italic">
            Mobil® Predictor
          </h1>
          <!-- <hr class="separador-preguntas-frecuentes"> -->
          <p class="font-white font-regular text-left mt-2 pf-text">
            Conviértete en el maestro de las predicciones de la Gran Carrera.
            Aquí encontrarás respuesta a todas tus dudas
          </p>
        </div>
      </div>
      <!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <img class="ChecoCascopFrecuentes" src="../../../assets/ChecoCasco.png" alt="Max">
      </div> -->
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="mb-5 text-center px-5">
          <h1 class="font-white font-regular text-center mb-3 italic">
            Preguntas Frecuentes
          </h1>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-expansion-panels
                class="paneles-preguntas-frecuentes mb-3 mx-auto font-regular"
                accordion
              >
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Qué es Mobil Predictor?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Mobil Predictor es una plataforma de predicciones creada
                      por Mobil™ donde podrás poner a prueba tus conocimientos
                      sobre las carreras de Oracle Red Bull Racing durante la
                      temporada. Con cada predicción correcta sumarás puntos y
                      podrás ascender posiciones en el tablero para competir por
                      increíbles premios. Cada carrera representa una nueva
                      oportunidad para demostrar qué tanto sabes de la máxima
                      categoría del automovilismo.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">¿Cómo jugar?</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Entra antes de cada carrera de F1™ y realiza tus
                      predicciones en la sección “Predicciones”. Recuerda que
                      deberás responder también una pregunta de la marca para
                      enviar tus respuestas. Las respuestas a estas preguntas
                      las podrás encontrar en mobil.com.mx, en nuestras redes
                      sociales o dentro de nuestro newsletter de Mobil Racing
                      Club.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Necesito registrarme?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Sí. Necesitas crear un usuario y contraseña para acceder a
                      la plataforma y participar en las predicciones.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">¿Es gratis?</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Sí, Mobil Predictor es una plataforma de participación
                      completamente gratuita.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Puedo jugar aunque la temporada ya haya empezado?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      ¡Claro! Puedes comenzar a participar en cualquier momento
                      de la temporada. Cada carrera representa una nueva
                      oportunidad para sumar puntos y subir posiciones en el
                      tablero.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Cuál es la fecha límite para hacer mis predicciones?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Las predicciones se abrirán el lunes a las 12:00 am de
                      cada semana en la que haya carrera de F1TM y cerrarán
                      antes del inicio de la clasificación (Qualy).Las carreras
                      con formato Sprint Race tendrán horarios especiales
                      dependiendo del circuito.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Cuáles son los premios?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      En Mobil Racing Club y Mobil Predictor premiamos a
                      nuestros campeones con merch exclusiva, colecciones
                      limitadas, productos oficiales de Oracle Red Bull Racing y
                      acceso a algunos de nuestros eventos más esperados del año
                      junto a invitados especiales. Además, contamos con
                      premiaciones por carrera y también reconocimientos para
                      los mejores participantes de toda la temporada. Mantente
                      atento a nuestras comunicaciones para conocer todas las
                      dinámicas y recompensas disponibles.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>

            <div
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12 separador-vertical-preguntas-frecuentes"
            >
              <v-expansion-panels
                class="paneles-preguntas-frecuentes mb-3 mx-auto font-regular"
                accordion
              >
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Está disponible en mi región?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Mobil Predictor y sus recompensas están disponibles
                      únicamente para participantes residentes en la República
                      Mexicana.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Qué tipo de predicciones puedo hacer y cómo me
                      benefician?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      En la pestaña “Predicciones” encontrarás preguntas
                      relacionadas con el desempeño y resultados de los pilotos
                      de Oracle Red Bull Racing, así como preguntas especiales
                      sobre MobilTM. Cada respuesta correcta te ayudará a
                      acumular puntos.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Cuándo y dónde veré mi puntuación?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Podrás consultar tu puntuación en la sección “Tabla de
                      Posiciones”. Tus puntos aparecerán reflejados los lunes
                      después de los domingos de carrera.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Cómo puedo alcanzar la cima de la tabla de clasificación?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Cada pregunta tiene un valor específico en puntos.
                      Mientras más predicciones correctas y preguntas de MobilTM
                      respondas acertadamente, mayores serán tus posibilidades
                      de subir posiciones carrera tras carrera.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Qué puedo hacer si tengo problemas para acceder a mi
                      cuenta?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Selecciona la opción “Restablecer contraseña” en la página
                      de inicio y te ayudaremos a recuperar el acceso al correo
                      que tengas registrado en Mobil Racing Club.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      No encuentro la respuesta a mi pregunta sobre Mobil
                      Predictor. ¿Qué debo hacer?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Escríbenos a info@mobilpredictor.com.mx para recibir más
                      información. También te recomendamos consultar nuestros
                      Términos y Condiciones para resolver dudas adicionales.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Esta es una iniciativa de Oracle Red Bull Racing?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Mobil Predictor no está asociado directamente con Oracle
                      Red Bull Racing. Esta plataforma pertenece a Mobil México
                      y forma parte de Mobil Racing Club, el club de fans
                      oficial de Mobil.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="panel-pregunta-frecuente mb-2">
                  <v-expansion-panel-header class="text-center">
                    <h3 class="titulo-pregunta-frecuente">
                      ¿Cuál es la diferencia entre Mobil Racing Club y Mobil
                      Predictor?
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center">
                    <p class="texto-pregunta-frecuente">
                      Mobil Racing Club es el club oficial de fans de
                      motorsports de Mobil México. Al formar parte de la
                      comunidad, tendrás acceso a contenido exclusivo, merch,
                      dinámicas especiales y experiencias relacionadas con el
                      mundo del automovilismo. Dentro de Mobil Racing Club
                      también podrás acceder a Mobil Predictor, el juego donde
                      podrás hacer predicciones sobre cada carrera, sumar puntos
                      y competir por premios exclusivos durante toda la
                      temporada.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./preguntasFrecuentes.scss" lang="scss" />
<script src="../iniciarSesion/iniciarSesion.js" />
<style src="../iniciarSesion/iniciarSesion.scss" lang="scss" />

<script>
export default {
  name: "PreguntasFrecuentes",
  metaInfo: {
    title: "FAQ| Mobil Predictor ",
    meta: [
      { name: "title", content: "FAQ| Mobil Predictor " },
      {
        name: "description",
        content:
          "Resuelve dudas sobre pronósticos, premios y registro. Encuetra lo que debes saber para ganar premios por apoyar a Max Verstappen y RBR en la temporada 2026.",
      },
    ],
  },
};
</script>
